import lodashGet from "lodash/get";

import {
  GET_HOTSPOTS,
  GET_HOTSPOTS_PARAMS,
  GET_HOTSPOTS_REFRESH_MAP,
  GET_HOTSPOTS_DETAILS,
  GET_HOTSPOTS_DETAILS_SELECTED_TAB,
  GET_HOTSPOTS_DETAILS_PARAMS,
} from "./actions.type";

import {
  SET_HOTSPOTS,
  SET_HOTSPOTS_PARAMS,
  SET_HOTSPOTS_REFRESH_MAP,
  SET_HOTSPOTS_DETAILS,
  SET_HOTSPOTS_DETAILS_SELECTED_TAB,
  SET_HOTSPOTS_DETAILS_KEYWORDS,
  SET_HOTSPOTS_DETAILS_PARAMS,
} from "./mutations.type";

import {
  getHotspots,
  getHotspotsByGeohash,
} from "@/services/grids/hotspots.service";

const STATE = {
  hotspots: {
    features: [],
    refreshMap: false,
    enabled: false,
    params: {
      timestamp: null,
    },
    details: {
      selectedTab: null,
      params: null,
      feature: null,
      keywords: [],
      content: {},
    },
  },
};

const GETTERS = {
  hotspots: (state) => state.hotspots,
};

const ACTIONS = {
  async [GET_HOTSPOTS](context, params) {
    try {
      const RESULT = await getHotspots(params);
      context.commit(SET_HOTSPOTS, RESULT.features);
    } catch (error) {
      console.error("Error in GET_HOTSPOTS actions: " + error);
    }
  },
  [GET_HOTSPOTS_PARAMS](context, params) {
    params.timestamp = Date.now();
    context.commit(SET_HOTSPOTS_PARAMS, params);
  },
  [GET_HOTSPOTS_REFRESH_MAP](context, params) {
    context.commit(SET_HOTSPOTS_REFRESH_MAP, params);
  },
  async [GET_HOTSPOTS_DETAILS](context, params) {
    try {
      const RESULT = await getHotspotsByGeohash(params);

      let details = context.state.hotspots.details;
      if (
        RESULT &&
        RESULT.features &&
        Array.isArray(RESULT.features) &&
        RESULT.features[0]
      ) {
        details.feature = RESULT.features[0];
      }

      details.params = params;

      context.commit(SET_HOTSPOTS_DETAILS, details);
    } catch (error) {
      console.error("Error in SET_HOTSPOTS_DETAILS actions: " + error);
    }
  },
  [GET_HOTSPOTS_DETAILS_SELECTED_TAB](context, params) {
    context.commit(SET_HOTSPOTS_DETAILS_SELECTED_TAB, params);
  },
  [GET_HOTSPOTS_DETAILS_PARAMS](context, params) {
    params.timestamp = Date.now();
    context.commit(SET_HOTSPOTS_DETAILS_PARAMS, params);
  },
};

const MUTATIONS = {
  [SET_HOTSPOTS](state, data) {
    state.hotspots = data;
  },
  [SET_HOTSPOTS_PARAMS](state, data) {
    state.hotspots.params = data;
  },
  [SET_HOTSPOTS_REFRESH_MAP](state, data) {
    state.hotspots.refreshMap = data ? new Date().toISOString() : false;
  },
  [SET_HOTSPOTS_DETAILS](state, data) {
    state.hotspots.details = data;
  },
  [SET_HOTSPOTS_DETAILS_SELECTED_TAB](state, data) {
    state.hotspots.details.selectedTab = data;
  },
  [SET_HOTSPOTS_DETAILS_KEYWORDS](state, data) {
    state.hotspots.details.keywords = data;
  },
  [SET_HOTSPOTS_DETAILS_PARAMS](state, data) {
    state.hotspots.details.params = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
